<template>
  <div
    id="search-fednet"
    v-loading="loading">
    <!-- <div class="pay-header">
      Choose a plan
    </div> -->
    <div class="pay-content">
      <div class="pay-info">
        <div class="grid-name">
          {{ iframeData.gridName }}
        </div>
      </div>
      <div class="plan-list scroll-css">
        <div
          v-for="item in planList"
          :key="item.id"
          :class="['plan-detail', selectPlanId == item.id ? 'select': '']"
          @click="selectPlan(item.id)"
        >
          <div class="plan-name">{{item.name }}</div>
          <div
            class="price-info"
            v-html="item.priceInfo"></div>
          <div
            class="plan-desc"
            v-html="item.description">{{ item.description }}</div>
          <div
            class="select-box"
            v-show="selectPlanId == item.id"><i class="el-icon-check"></i></div>
        </div>
      </div>
    </div>
    <div class="pay-footer">
      <div class="confirm">
        <el-button
          @click="handleCheckOut"
          :disabled="!selectPlanId">Confirm</el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="360px"
      :modal="false"
      custom-class="free-dialog search-dialog"
      :before-close="handleClose"
    >
      <img
        src="@/assets/svg/allright.svg"
        alt="">
      <!-- <div class="start" v-if="planisSub">START TRIAL</div> -->
      <div class="start">Your Subscription has been Modified</div>
      <!-- <div class="start" v-if="planIsPostPay">POST PAY COMPLETE</div> -->

      <div class="info">Thank you, your subscription has been successfully modified, and the changes have been applied to your account. You may resume use.</div>
      <!-- <div class="info" v-if="planIsPostPay">Thank you, We will follow-up centralized deduction. You can start use it now.</div> -->
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="handleClose">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPlans, handleNewSub, queryPrice } from '@/common/checkuser.js'
import { Message } from 'element-ui'
export default {
  data () {
    return {
      selectPlanId: '',
      queryPlanLoading: false,
      checkOutLoading: false,
      planList: [],
      dialogVisible: false,
      payType: ''
    }
  },
  created () {
    this.handleGetPlans()
  },
  methods: {
    selectPlan (id) {
      this.selectPlanId = id
    },
    handleClose () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    handlePaySuccess () {
      const params = {
        type: 'success',
        from: 'billing',
        data: this.iframeData.payType
      }
      window.parent.postMessage(params, '*')
    },
    handlePayStep (description) {
      const params = {
        type: 'step',
        from: 'billing',
        data: {
          info: 'payError',
          description,
          payType: this.iframeData.payType
        }
      }
      window.parent.postMessage(params, '*')
    },
    handleGetPlans () {
      this.queryPlanLoading = true
      if (this.iframeData && this.iframeData.objectId) {
        const params = {
          customerId: this.emailid,
          product: 'Tvusearch',
          objectId: this.iframeData.objectId,
          excludeGlobal: true
        }
        getPlans(params).then(({ data }) => {
          if (data) {
            this.queryPlanLoading = false
            this.planList = data.plan.plans
            // console.log(this.planList, data.plan.plans);
            if (this.iframeData.payType != 1) {
              // 删除fednet
              const index = this.planList.findIndex(i => i.id.indexOf('fednet') > -1)
              console.log(index, 'index')
              index > -1 && this.planList.splice(index, 1)
            }
            this.planList.forEach(i => {
              i.priceInfo = null
              // this.$forceUpdate
              if (i.metadata) {
                const metadata = JSON.parse(i.metadata)
                const price = metadata.price / 100
                const chargeCycle = this.handlecycle(i.chargeCycle)
                i.priceInfo = `<span style="font-size: 18px;color: #33AB4F;">$${price}</span> per ${chargeCycle}`
              } else {
                console.log(i)
                if (this.iframeData.type == 'download') {
                  const params = {
                    customerId: this.emailid,
                    product: 'Tvusearch',
                    planId: i.id,
                    chargeItems: JSON.stringify({ 'tvusearch-download': 1 })
                  }
                  queryPrice(params).then(({ data }) => {
                    const price = data.previewCustomSubscription.price / 100
                    i.priceInfo = `<span style="font-size: 18px;color: #33AB4F;">$${price}</span> per sec to Download`
                    this.$forceUpdate()
                  })
                } else if (this.iframeData.type == 'takelive') {
                  const params = {
                    customerId: this.emailid,
                    product: 'Tvusearch',
                    planId: i.id,
                    chargeItems: JSON.stringify({ 'tvusearch-takelive': 1 })
                  }
                  queryPrice(params).then(({ data }) => {
                    const price = data.previewCustomSubscription.price / 100
                    i.priceInfo = `<span style="font-size: 18px;color: #33AB4F;">$${price}</span> per min to Take Live`
                    this.$forceUpdate()
                  })
                }
              }
            })
            const item = this.planList[0]
            this.selectPlanId = item ? item.id : ''
            console.log(this.planList)
          }
        })
      } else {
        setTimeout(() => {
          this.handleGetPlans()
        }, 1000)
      }
    },
    handleCheckOut () {
      if (!this.selectPlanId) return false
      this.checkOutLoading = true
      const chargeItems = {}
      if (this.selectPlanId.indexOf('fednet') > -1) {
        chargeItems['tvusearch-download'] = 1
        chargeItems['tvusearch-takelive'] = 1
      } else {
        if (this.iframeData.type == 'download') {
          chargeItems['tvusearch-download'] = this.iframeData.duration
        } else if (this.iframeData.type == 'takelive') {
          chargeItems['tvusearch-takelive'] = 1
        }
      }
      const selectPlan = this.planList.find(i => i.id == this.selectPlanId)
      let name = ''
      if (this.iframeData.type == 'takelive') {
        name = this.iframeData.gridName
      } else if (this.iframeData.type == 'download') {
        name = this.iframeData.exportFilename
      }
      const params = {
        customerId: this.emailid,
        product: 'Tvusearch',
        planId: this.selectPlanId,
        objectId: this.iframeData.objectId,
        description: `${selectPlan.name} ${this.emailid} ${this.iframeData.type} (${name})`,
        chargeItems: JSON.stringify(chargeItems)
      }

      console.log(params)
      handleNewSub(params, this).then(res => {
        console.log(res)
        // 支付成功
        this.handlePaySuccess()
        this.checkOutLoading = false
        this.dialogVisible = true
        if (res.info == 'paySuccess') {
          this.payType = 'paid'
        } else if (res.info == 'POST-PAY') {
          this.payType = 'postpay'
        }
      }).catch((err) => {
        this.handlePayStep(err.info)
        Message.error({
          message: err.info,
          duration: 5000
        })
        this.checkOutLoading = false
      })
    },
    handlecycle (cycle) {
      return cycle === 1 ? 'Week' : cycle === 2 ? 'month' : cycle === 3 ? 'Year' : ''
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email,
      iframeData: 'iframeData'
    }),
    loading () {
      return this.checkOutLoading || this.queryPlanLoading
    }
  }
}
</script>

<style lang="less" scoped>
#search-fednet {
  width: 408px;
  margin: 0 auto;
  min-height: 446px;
  text-align: left;
  position: relative;
  top: -20px;
  .pay-header {
    color: var(--text-color-01);
    font-weight: 700;
    line-height: 32px;
    border-bottom: 1px solid var(--dialog-border-color);
    margin: 0 20px;
    padding-bottom: 15px;
    font-size: 24px;
  }
  .pay-info {
    margin: 0 20px;
    border-bottom: 1px solid var(--dialog-border-color);
    padding: 20px 0;
    .slug-date, .grid-name {
      font-size: 18px;
      color: var(--text-color-01);
      font-weight: 700;
    }
  }
  .plan-list {
    padding: 0 20px;
    overflow-y: scroll;
    height: 320px;
    .plan-detail {
      padding: 20px 10px;
      border: 1px solid #aaa;
      border-radius: 10px;
      margin: 15px 0;
      transition: all .2s linear;
      position: relative;
      overflow: hidden;
      .plan-name {
        font-size: 18px;
        color: var(--text-color-01);
        font-weight: 700;
      }
      .plan-desc {
        font-size: 14px;
      }
      .price-info {
        margin: 10px 0;
      }
      .select-box {
        position: absolute;
        width: 40px;
        height: 40px;
        right: -20px;
        top: -20px;
        background-color: #33AB4F;
        transform: rotate(45deg);
        .el-icon-check {
          color: #FFF;
          background: #33AB4F;
          border: none;
          position: absolute;
          bottom: 0px;
          right: 2px;
          transform: rotate(-45deg);
          font-size: 12px;

        }
      }
    }
    .plan-detail:hover, .select {
      // transform: scale(1.04);
      box-shadow: 0 15px 30px #0001;
      transform: translate3d(0,-2px,0);
    }
    .select {
      border: 1px solid #33AB4F;
    }
  }
  .pay-footer {
    width: calc(100% - 40px);
    // height: 80px;
    padding-top: 5px;
    margin: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    justify-content: right;
    align-items: center;
    border-top: 1px solid var(--dialog-border-color);
  }
  .el-button {
    background: #33AB4F;
    color: #dbdbdb;
    padding: 12px 30px;
    border: none;
  }
}
/deep/ .free-dialog.search-dialog {
  // height: 275px;
  border-radius: 15px;
  .start {
    color: #000;
    font-weight: 700;
    margin: 10px 0;
  }
  .info {
    // width: 200px;
    margin: 0 auto;
    font-weight: 400;
    color: #979797;
    font-size: 14px;
    line-height: 16px;
    word-break: break-word;
  }
  .el-icon-close {
    color: #979797;
  }
  .el-dialog__body {
    text-align: center;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
